export const NAME = 'content';
export const FORM_NAME = 'contentForm';
